import React from "react";

import AsyncSelectInput from "../../../../../components/Inputs/AsyncSelectInput";
import { Result } from "../../../../../components/Inputs/SelectInput";

import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: string;
}

const RolePicker = (props: BaseProps) => {
	const { onChange, value } = props;
	const [valueLabelRoleMaps] = useQueryBuilderStore((state) => [state.valueLabelMaps.roles]);
	const [fetchRoles] = useQueryBuilderStore((state) => [state.fetchRoles]);

	// value is only the role id; resolve its label from the store cache, which is primed
	// by initValueLabelMaps (fetch-by-id for saved filters) and by any searched roles.
	let displayValue;
	if (value && valueLabelRoleMaps[value]) {
		displayValue = { value, label: valueLabelRoleMaps[value] } as Result;
	}

	return (
		<AsyncSelectInput placeholder="Select..." fetchOptions={fetchRoles} onChange={onChange} value={displayValue} />
	);
};

export default RolePicker;
